import service from '@/utils/server';

const modName='/bd/orderQuery/';

//initPage
export const initPage = data => {
  return service({
    url: modName + 'initPage',
    method: 'post',
    data
  });
};

//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};
//初始化更新对象
export const initUpdate = data => {
  return service({
    url: modName + 'orderDetail',
    method: 'post',
    data
  });
};
//修改方法
export const editData = data => {
  return service({
    url: modName + 'orderEdit',
    method: 'post',
    data
  });
};

//订单取消
export const cancleOrder = data => {
  return service({
    url: modName + 'cancel',
    method: 'post',
    data
  });
};

//导出
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};

//查询总利润
export const selectTotalProfit = data => {
  return service({
    url: modName + 'summaryAmount',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/zhubo/orderQuery/api/index.js